import { render, staticRenderFns } from "./short-messages.vue?vue&type=template&id=49474f7f&scoped=true&"
import script from "./short-messages.vue?vue&type=script&lang=js&"
export * from "./short-messages.vue?vue&type=script&lang=js&"
import style0 from "./short-messages.vue?vue&type=style&index=0&id=49474f7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49474f7f",
  null
  
)

export default component.exports